import axios from "axios";

const metadataReportOverviewURL = "/api/v1/metadata_report_overview";

const metadataReportOverviewApi = {
  fetch: (page = 1, pageSize = 10, sort, filters) =>
    axios.get(metadataReportOverviewURL, {
      params: { page, per_page: pageSize, sort, filters },
    }),
  data_sources: filters =>
    axios.get(`${metadataReportOverviewURL}/data_sources`, {
      params: { filters },
    }),
  domains: filters =>
    axios.get(`${metadataReportOverviewURL}/domains`, { params: { filters } }),
  subdomains: () => axios.get(`${metadataReportOverviewURL}/subdomains`),
  cdes: () => axios.get(`${metadataReportOverviewURL}/cdes`),
};

export default metadataReportOverviewApi;
